<template>
  <div class="teacher-card-container">
    <div class="teacher-card" @click="openDetail">
      <div class="teacher-info-wrapper">
        <div class="teacher-info">
          <div class="teacher-name">{{ teacherData.teacher_name }}</div>
          <div class="teacher-organ">{{ teacherData.organ_name }}</div>
        </div>
        <div class="teacher-avatar">
          <img :src=" teacherData.teacher_avatar_url || require('@/assets/images/common/teacher_icon.png') " alt=""/>
        </div>
      </div>
      <div class="split-line"></div>
      <div class="teacher-intro" v-html="$utils.getContentText(teacherData.introduction)"></div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    teacherData: {
      required: true,
      defalut: {},
      type: Object,
    },
    menu: Object,
  },
  methods: {
    openDetail() {
      window.open(
        `/teacherDetailInfo.html?id=${this.teacherData.teacher_id ||
          this.teacherData.id}&usercode=${this.teacherData.usercode}&name=${
          this.menu.module_name
        }&menuId=${this.menu.menu_id}`
      );
    },
  },
};
</script>
<style lang="scss" scoped>
.teacher-card-container {
  &:hover, &.active {
    .teacher-card {
      transform: translate(0px, -24px);
      transition: all 0.5s ease;
      background: #194189;
      .teacher-info-wrapper {
        .teacher-info {
          .teacher-name {
            color: #FFFFFF;
          }
          .teacher-organ {
            color: rgba(255, 255, 255, 0.6);
          }
        }
        .teacher-avatar {
          transition: all 0.5s ease;
          opacity: 1;
        }
      }
      .split-line {
        background-color: #fff;
      }
      .teacher-intro {
        color: #FFFFFF;
      }
    }
  }
  .teacher-card {
    background: #F7F8FA;
    padding: 20px 24px 40px;
    cursor: pointer;
    border-radius: 12px;
    font-family: "PingFang SC";
    width: 302px;
    height: 302px;
    .teacher-info-wrapper {
      display: flex;
      justify-content: space-between;
      .teacher-info {
        .teacher-name {
          color: #1D2129;
          font-size: 20px;
          font-weight: 500;
        }
        .teacher-organ {
          color: #86909C;
          font-size: 14px;
          font-weight: 400;
        }
      }
      .teacher-avatar {
        opacity: 0;
        img {
          width: 80px;
          height: 80px;
          border-radius: 12px;
        }
      }
    }
    .split-line {
      width: 48px;
      height: 8px;
      background-color: #194189;
    }
    .teacher-intro {
      margin-top: 12px;
      color: #1C212A;
      font-size: 16px;
      font-weight: 400;
      height: 140px;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 6;
      -webkit-box-orient: vertical;
      white-space: normal;
      line-height: 1.5;
    }
  }
}
</style>
